export class RegisterPaymentDto {
  constructor(
      public userId: string,
      public tokenId: string,
      public paymentValue: number,
      public dateOfPayment: string,
      public products: number[]
  ) { }
}
